import React from "react";
import { useTranslation } from "lib/i18n";

const Footer = () => {
  const { t } = useTranslation();

  // Get the current year
  const year = new Date().getFullYear();
  
  return (
    <footer aria-label="Site footer">
      <div className="container text-white">
        <div className="row align-items-center">
          <div className="col-sm-12">
            <p className="mt-4 mb-4 title-font-2">
              {t("footer.rights", { year })}
            </p>
            <div className="footer-links title-font-2" aria-label="Legal links">
              <a href="/privacy">{t("footer.privacy")}</a>
              <span className="footer-divider" aria-hidden="true">
                |
              </span>
              <a href="/terms">{t("footer.terms")}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
